module.exports = {
      id: "icon-audio-instagram-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-audio-instagram",
      toString: function () {
        return this.url;
      }
    }